module.exports = __webpack_public_path__ + "portal-static/img/paihangbang1.9378ccf5.png";